import { FC, useState } from 'react';

import { SearchIcon } from '../../../../../assets/icons/index';
import { useDebounce, useLocale } from '../../../../../hooks/index';

export const MobileSearchField: FC<{ onSearch: (search: string) => void }> = ({ onSearch }) => {
  const { messagesLocale } = useLocale();
  const [value, setValue] = useState('');
  const { debounceCallback } = useDebounce({ callback: onSearch });

  return (
    <label className="flex h-9 w-full items-center gap-2 rounded-t border-b border-gray-700 bg-gray-50 p-2">
      <input
        aria-label={messagesLocale['SEARCH']}
        className="min-w-0 flex-1 bg-transparent text-sm font-[450] leading-5 text-gray-700 outline-none placeholder:text-gray-400"
        onChange={({ target }) => {
          setValue(target.value);
          debounceCallback(target.value);
        }}
        placeholder={messagesLocale['SEARCH']}
        type="search"
        value={value}
      />
      <SearchIcon className="size-5" height={20} width={20} />
    </label>
  );
};
